import React from 'react';
import FilterTable from './filterTable';
import { TrialSettingsHistoryTableColumnCaptions } from './tableColumnCaptions';
import { jsonColumn } from './tableUtils';

const TrialSettingsHistoryTable = (props) => {
	const columns = [
		{
			dataField: 'eventDateTime',
			text: 'Event time',
			sort: true,
			filter_: { type: 'datetime' },
		},
		{
			dataField: 'eventName',
			text: 'Event name',
			sort: true,
			filter_: { type: 'text' },
		},
		{
			dataField: 'previous',
			text: 'Previous values',
			filter_: { type: 'text' },
		},
		{
			dataField: 'user.login',
			text: 'User',
			sort: true,
			filter_: { type: 'text' },
		},
	];

	const defaultSorted = [
		{
			dataField: 'eventDateTime',
			order: 'desc',
		},
	];

	return (
		<FilterTable
			{...props}
			objectName='trialSettingsHistory'
			data={props.history.map((histrec) => ({
				...histrec,
				previous: jsonColumn(histrec.previousValues, TrialSettingsHistoryTableColumnCaptions),
			}))}
			columns={columns}
			defaultSorted={defaultSorted}
			noDataIndication='There are no trial settings history records'
		/>
	);
};

export default TrialSettingsHistoryTable;



// WEBPACK FOOTER //
// ./src/components/trialSettingsHistoryTable.js